import { Component, OnInit, Optional } from '@angular/core';
import { ControlContainer, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseFpxFormComponent } from '@fpx/core';
import { ProcessShellService } from '../services/process-shell.service';
import { SettingsResultPageHelper, SettingsResultPageState } from './settings-result-page.helper';
import { SettingsResultPageService } from './services/settings-result-page.service';


@Component({
  selector: 'app-settings-result-page',
  templateUrl: './settings-result-page.component.html',
  styleUrls: ['./settings-result-page.component.scss'],
  providers: [
    SettingsResultPageHelper
  ]
})
export class SettingsResultPageComponent extends BaseFpxFormComponent<SettingsResultPageHelper, SettingsResultPageState> {

  constructor(

    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private _router: Router,
    public settingsResultPageService:SettingsResultPageService,
    public formHelper: SettingsResultPageHelper,
    public _processShellService: ProcessShellService

  ) {
    super(formBuilder, _router, controlContainer, formHelper);
  }
  

}
